import { render, staticRenderFns } from "./UploadProfilePicture2.vue?vue&type=template&id=63f892e5&scoped=true"
import script from "./UploadProfilePicture2.vue?vue&type=script&lang=js"
export * from "./UploadProfilePicture2.vue?vue&type=script&lang=js"
import style0 from "./UploadProfilePicture2.vue?vue&type=style&index=0&id=63f892e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f892e5",
  null
  
)

export default component.exports